import APIClient from '@/shared/http/clients/api'

const resourceName = 'parametros/classe-a'
const APICore = process.env.APIBaseURLCore

const GetAll = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/`, data, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/${data.id}`, data, config)

const ParametroClasseA = {
  GetAll,
  Create,
  Update
}

export default ParametroClasseA



// WEBPACK FOOTER //
// ./src/shared/http/repositories/configurations/parametroClasseA.js